module.exports = __webpack_public_path__ + "static/media/ny-che-routes.d8d04a4b.png";